import { useState, useEffect } from 'react'
import { useParams, useNavigate, useLocation } from "react-router-dom";
import parse from 'html-react-parser';
import generatePDF,{ usePDF } from 'react-to-pdf';
// services
import * as webBridgeService from '../../../services/webBridgeService'
// styles
import styles from "./LeadCaptureOrder.module.css"
// ------ Components ------ //
import LoadingSpinner from "../../Miscellaneous/LoadingSpinner"

const Confirmation = () => {
    const location = useLocation();
    const navigate = useNavigate()
    const confirmationOrder = location.state;
    const [loaded, setLoaded] = useState(false);
    const [confirmationForm, setConfirmationForm] = useState(null);
    //const [height, setHeight] = useState('0px');
    const { refNumber } = useParams()
    const { toPDF, targetRef } = usePDF({});
    const [pdfName, setPdfName] = useState(null);
    const getConfirmationForm = async (refNum) => {
        let confForm = await webBridgeService.getConfirmationForm(refNum, true);
        if (confForm) {
            setConfirmationForm(confForm);
        }

        if (confirmationOrder && confirmationOrder.account) {
            setPdfName(confirmationOrder.account.firstName + '_' + confirmationOrder.account.lastName + '_' + confirmationOrder.account.organization + '.pdf');
        }
        else {
            setPdfName('order_' + refNum + '.pdf');
        }
        
        setLoaded(true);
    }
    //function resizer(id) {        // use if want iframe version
    //    if (document.getElementById(id)) {
    //        var doc = document.getElementById(id).contentWindow.document;
    //        var body_ = doc.body, html_ = doc.documentElement;
    //        if (body_ && html_) {
    //            var height = Math.max(body_.scrollHeight, body_.offsetHeight, html_.clientHeight, html_.scrollHeight, html_.offsetHeight);
    //            setHeight(height);
    //        }
    //    }
    //    else {
    //        setHeight(1000);
    //    }
    //}
    //useEffect(() => {
    //    if (confirmationForm) {
    //        setTimeout(() => {
    //            resizer('iframeConfirmation');
    //        }, 200)
    //    }

    //}, [confirmationForm])
    //<iframe
    //    height={height}
    //    width="100%"
    //    overflow="visible"
    //    id="iframeConfirmation"
    //    title="confirmation_iframe"
    //    marginheight="0"
    //    frameBorder="0"
    //    border="0"
    //    scroll="no"
    //    srcDoc={JSON.parse(confirmationForm)}
    //></iframe>
    useEffect(() => {
        let refNum = refNumber && refNumber > 0 ? refNumber : confirmationOrder && confirmationOrder.account ? confirmationOrder.account.refNumber : null;
        if (refNum) {
            getConfirmationForm(refNum);
        }
        else {
            setLoaded(true);
        }

    }, [])
    return (
        <>{!loaded ? <LoadingSpinner /> :
            <div>
                <h2>Thank you for you order!</h2><br />
                {
                    confirmationForm && confirmationForm!== undefined ?
                        <>
                            <button onClick={() => generatePDF(targetRef, { filename: pdfName })}>Download to PDF</button>
                            <br />
                            <br />
                            <div ref={targetRef}>
                                {parse(JSON.parse(confirmationForm))}
                            </div>
                            <br />
                            <br />
                        </>
                        :
                        <div>Error in confirmation html...</div>
                }
                <br />
                <div className={styles.footer }>
                    <br /> <br />
                    For all inquiries, please email us at <a href="mailto:itevents@smithbucklin.com">itevents@smithbucklin.com</a>
                </div>
            </div>


        }
        </>


    );
}
export default Confirmation;
